var NOTIFICATION_VARIANT = {
    ERROR: 'error',
    INFO: 'info',
    SUCCESS: 'success',
    WARN: 'warn'
}

module.exports = NOTIFICATION_VARIANT
